import React from 'react';
import { string } from 'prop-types';
import typograf from 'utils/typograf';

const Copyright = ({ copyright, client }) => (
  <div className="copyright">
    <div className="copyright__client">
      <span className="text text-semi">{typograf(client)}</span>
    </div>

    <div style={{ fontSize: 18 }}>
      <a
        href="/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="link link-black link-undecorated"
      >
        Политика в отношении обработки персональных данных
      </a>
      <br />
      <a
        href="/user-agreement"
        target="_blank"
        rel="noopener noreferrer"
        className="link link-black link-undecorated"
      >
        Пользовательское соглашение
      </a>
      <br />
      <a
        href="/consent-personal-data"
        target="_blank"
        rel="noopener noreferrer"
        className="link link-black link-undecorated"
      >
        Согласие на обработку персональных данных
      </a>
      <br />
      <a
        href="/cookie-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="link link-black link-undecorated"
      >
        Политика испльзования cookies
      </a>
    </div>

    <div style={{ marginTop: 15 }}>
      <span className="text text-hint text-semi">
        Раньше наша компания называлась Эксклюзив
      </span>
    </div>

    <div>
      <a
        style={{ fontSize: 14, marginTop: '1rem' }}
        href="http://propellers.team"
        title="Developed by Propellers since 2019"
        className="link link-black link-undecorated propeller"
      >
        {typograf(copyright)}
      </a>
    </div>
  </div>
);

Copyright.propTypes = {
  client: string.isRequired,
  copyright: string.isRequired,
};

export default Copyright;
